import React from 'react';
import { Link } from 'react-router-dom';
import { Sun, Mail, Phone, Clock } from 'lucide-react';

const Footer = () => {
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  return (
    <footer className="footer" data-testid="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <Link to="/" className="logo" onClick={handleLinkClick}>
            <div className="logo-icon">
              <Sun size={22} />
            </div>
            <div className="logo-text">
              <div className="logo-title">Dr. <span>Drea</span></div>
              <div className="logo-subtitle">Sober Coaching</div>
            </div>
          </Link>
          <p>Professional sober coaching services to support your recovery journey with compassion and expertise.</p>
        </div>

        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/" onClick={handleLinkClick} data-testid="footer-home">Home</Link></li>
            <li><Link to="/get-started" onClick={handleLinkClick} data-testid="footer-get-started">Get Started</Link></li>
            <li><Link to="/resources" onClick={handleLinkClick} data-testid="footer-resources">Resources</Link></li>
            <li><Link to="/payment" onClick={handleLinkClick} data-testid="footer-payment">Make a Payment</Link></li>
            <li><Link to="/contact" onClick={handleLinkClick} data-testid="footer-contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-contact">
          <h4>Contact Info</h4>
          <p><Mail size={16} /> drea@drdreasobercoaching.com</p>
          <p><Phone size={16} /> Available during business hours</p>
          <p><Clock size={16} /> Mon-Fri: 9am - 6pm PST</p>
        </div>
      </div>

      <div className="crisis-box" data-testid="crisis-box">
        <h4>In Crisis?</h4>
        <p>If you're experiencing a mental health emergency, please contact:</p>
        <p><strong>988 Suicide & Crisis Lifeline:</strong> Call or text 988</p>
        <p><strong>SAMHSA Helpline:</strong> 1-800-662-HELP (4357)</p>
      </div>

      <div className="footer-bottom">
        <p>© 2025 Dr. Drea Sober Coaching. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
